import type { ComponentProps, ComponentType, FC, ReactNode } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Collapsible, NavBarIcon } from "@similarweb/ui-components";

import { AccordionWrapper, AccordionHeadContainer } from "app/components/Accordion/AccordionStyled";

interface IAccordion {
    accordionHeadComponent: ReactNode;
    isOpen: boolean;
    onClick: () => void;
    showToggleIcon?: boolean;
    wrapperComponent?: ComponentType<ComponentProps<typeof AccordionWrapper>>;
    children: ReactNode;
}

export const Accordion: FC<IAccordion> = ({
    children,
    accordionHeadComponent,
    isOpen,
    onClick,
    showToggleIcon = true,
    wrapperComponent = AccordionWrapper,
}) => {
    const Wrapper = wrapperComponent;
    return (
        <Wrapper isOpen={isOpen}>
            <AccordionHeadContainer
                data-automation={"accordion-head-container"}
                isOpen={isOpen}
                onClick={onClick}
            >
                {accordionHeadComponent}
                {showToggleIcon ? (
                    <div data-automation={"accordion-arrow-icon"}>
                        <NavBarIcon
                            iconName={isOpen ? "chev-down" : "chev-right"}
                            iconSize="xs"
                            iconColor={colorsPalettes.carbon[400]}
                        />
                    </div>
                ) : null}
            </AccordionHeadContainer>
            <Collapsible isActive={isOpen}>{children}</Collapsible>
        </Wrapper>
    );
};
